import { AlertSpecificationOutput } from './alert-specification-output.model';


export class AlertSpecificationAddOutput implements IAlertSpecificationAddOutput {
    status!: number;
    message!: string;
    data!: AlertSpecificationOutput;

    constructor(data?: IAlertSpecificationAddOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? AlertSpecificationOutput.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AlertSpecificationAddOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AlertSpecificationAddOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAlertSpecificationAddOutput {
    status: number;
    message: string;
    data: AlertSpecificationOutput;
}

